export default {
  disabled: (state) => {
    console.log(state.password === '')
    return state.password === ''
  }
}
